<template>
  <div class="page adv-page">
    <router-link class="adv-back" to="/advisories">← {{ t('backList') }}</router-link>
    <div v-if="loading" class="empty">{{ t('loading') }}</div>
    <article v-else-if="item" class="adv-article">
      <header class="adv-head">
        <div class="adv-kicker">{{ item.advisoryNo }}</div>
        <h1>{{ item.title }}</h1>
        <div class="adv-tags">
          <span class="tag" :class="tagClass(item.severity)">{{ sevText(item.severity) }}</span>
          <span class="tag ok">{{ t('published') }}</span>
        </div>
      </header>
      <div class="adv-meta">
        <dl>
          <dt>{{ t('cve') }}</dt>
          <dd>{{ item.cveIds || '-' }}</dd>
        </dl>
        <dl>
          <dt>{{ t('exploitStatus') }}</dt>
          <dd>{{ exploitText(item.exploitStatus) }}</dd>
        </dl>
        <dl>
          <dt>{{ t('publishedAt') }}</dt>
          <dd>{{ formatTime(item.publishedAt) }}</dd>
        </dl>
        <dl>
          <dt>{{ t('lastUpdatedAt') }}</dt>
          <dd>{{ formatTime(item.lastUpdatedAt || item.publishedAt) }}</dd>
        </dl>
      </div>
      <section v-if="affectedItems.length" class="adv-section">
        <h2>{{ t('affectedFixTitle') }}</h2>
        <div class="table-wrap adv-affected-wrap">
          <table class="adv-affected-table">
            <thead>
              <tr>
                <th>{{ t('affectedProductCol') }}</th>
                <th>{{ t('affectedVersionCol') }}</th>
                <th>{{ t('fixedVersionCol') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in affectedItems" :key="idx">
                <td>{{ row.product || '-' }}</td>
                <td>{{ row.affectedVersion || '-' }}</td>
                <td>{{ row.fixedVersion || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section class="adv-section">
        <h2>{{ t('body') }}</h2>
        <p>{{ item.body }}</p>
      </section>
      <div v-if="item.mitigation || item.userAction" class="adv-extra">
        <section v-if="item.mitigation" class="adv-section">
          <h2>{{ t('mitigation') }}</h2>
          <p>{{ item.mitigation }}</p>
        </section>
        <section v-if="item.userAction" class="adv-section">
          <h2>{{ t('userAction') }}</h2>
          <p>{{ item.userAction }}</p>
        </section>
      </div>
    </article>
    <div v-else class="empty">{{ t('emptyAdv') }}</div>
  </div>
</template>
<script>
import { t } from '../i18n'
import { mapState } from 'vuex'
import { portalApi } from '../api/portalApi'

export default {
  name: 'AdvisoryDetail',
  props: { id: { type: String, default: '' } },
  data() {
    return { item: null, loading: false }
  },
  computed: {
    ...mapState(['locale']),
    advisoryId() {
      return this.id || (this.$route && this.$route.params && this.$route.params.id) || ''
    },
    affectedItems() {
      if (!this.item) {
        return []
      }
      if (Array.isArray(this.item.affectedItems) && this.item.affectedItems.length) {
        return this.item.affectedItems
      }
      if (this.item.affectedProduct) {
        return [{ product: this.item.affectedProduct, affectedVersion: '', fixedVersion: '' }]
      }
      return []
    }
  },
  watch: {
    advisoryId: {
      immediate: true,
      handler(val) {
        if (!val) return
        this.loading = true
        this.item = null
        portalApi.advisory(val).then((data) => {
          this.item = data
        }).catch(() => {
          this.item = null
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    },
    formatTime(value) {
      if (!value) return '-'
      const text = String(value)
      return text.length >= 10 ? text.slice(0, 16) : text
    },
    sevText(code) {
      return ({
        critical: this.t('sevCritical'),
        high: this.t('sevHigh'),
        medium: this.t('sevMedium'),
        low: this.t('sevLow')
      })[code] || code
    },
    tagClass(code) {
      if (code === 'critical' || code === 'high') return 'danger'
      if (code === 'medium') return 'warn'
      return 'ok'
    },
    exploitText(code) {
      return ({ unknown: this.t('unknown'), none: this.t('no'), poc: 'POC', active: this.t('yes') })[code] || code
    }
  }
}
</script>
